import { useCallback, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import bookActions from 'store/modules/booking'
import bookSelectors from 'store/selectors/booking'
import adminActions from 'store/modules/admin'
import adminSelectors from 'store/selectors/admin'
import routerSelectors from 'store/selectors/router'
import routerActions from 'store/modules/router'
import useCalendar from './useCalendar'

const useAdminCalendar = ({
  project,
  bookingform,
  config,
  days,
  autoAdjustDate = true,
  useConfigCondensed = false,
} = {}) => {

  const dispatch = useDispatch()
  const params = useSelector(routerSelectors.params)

  const slotFilter = useSelector(adminSelectors.calendarSlotFilter)
  const setSlotFilter = useCallback((value) => {
    dispatch(adminActions.setCalendarSlotFilter(value))
  }, [])

  const calendarConfig = useMemo(() => {
    return config ? config.calendar_config || {} : {}
  }, [
    config,
  ])

  const calendarConfigCondensed = useMemo(() =>{
    return calendarConfig.condensed ? true : false
  }, [
    calendarConfig,
  ])

  let condensed = useSelector(adminSelectors.calendarCondensed)

  if(useConfigCondensed) condensed = calendarConfigCondensed

  // we can't have condensed in this calendar so don't try
  if(!calendarConfigCondensed) condensed = false

  const setCondensed = useCallback((value) => {
    dispatch(adminActions.setCalendarCondensed(value))
  }, [])

  const onUpdateDate = useCallback((date) => {
    dispatch(routerActions.addQueryParams({date}))
  }, [])

  const useDays = useMemo(() => {
    if(days) return days
    return calendarConfig.admin_days || 3
  }, [
    days,
    calendarConfig,
  ])

  const baseCalendar = useCalendar({
    project,
    bookingform,
    admin: true,
    days: useDays,
    reloadDelay: 5000,
    autoAdjustDate,
    initialDate: params.date,
    config,
    calendarConfig,
    condensed,
    slotFilter,
    dataSelector: bookSelectors.calendar,
    loadDataAction: bookActions.loadCalendar,
    onUpdateDate,
  })

  return Object.assign({}, baseCalendar, {
    setSlotFilter,
    setCondensed,
  })

}

export default useAdminCalendar